// Gauge rispetto SLA — RadialBarChart Recharts
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts'
import { Card, CardHeader, CardTitle } from '../../../components/ui/Card'
import { cn } from '../../../lib/utils'

interface SLAGaugeProps {
  compliance?: number // 0–100
  isLoading?: boolean
}

export function SLAGauge({ compliance = 0 }: SLAGaugeProps) {
  const color = compliance >= 90
    ? 'var(--fc-success)'
    : compliance >= 70
      ? 'var(--fc-warning)'
      : 'var(--fc-danger)'

  const data = [
    { value: compliance, fill: color },
  ]

  const label = compliance >= 90 ? 'Ottimo' : compliance >= 70 ? 'Sufficiente' : 'Critico'

  return (
    <Card>
      <CardHeader>
        <CardTitle>Rispetto SLA</CardTitle>
        <span className="text-xs text-[var(--fc-foreground-muted)]">Questo mese</span>
      </CardHeader>

      <div className="flex flex-col items-center">
        <div className="relative h-40 w-40">
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius={48}
              outerRadius={64}
              startAngle={220}
              endAngle={-40}
              data={data}
              aria-label={`SLA compliance: ${compliance}%`}
            >
              <RadialBar
                background={{ fill: 'var(--fc-gray-100)' }}
                dataKey="value"
                cornerRadius={8}
                max={100}
              />
            </RadialBarChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span
              className="text-2xl font-bold"
              style={{ color }}
            >
              {compliance}%
            </span>
            <span className="text-xs text-[var(--fc-foreground-muted)]">{label}</span>
          </div>
        </div>

        <div className="mt-3 flex gap-6 text-center text-xs text-[var(--fc-foreground-muted)]">
          <div>
            <p className="text-base font-semibold text-[var(--fc-foreground)]">
              {compliance}%
            </p>
            <p>Rispettati</p>
          </div>
          <div>
            <p className="text-base font-semibold text-[var(--fc-danger)]">
              {100 - compliance}%
            </p>
            <p>Scaduti</p>
          </div>
        </div>
      </div>
    </Card>
  )
}
